import { cn } from "./classNames-DcGnTh2N.js";
import { X } from "./icons-ZIeZXXS7.js";
import { Button } from "./Button-D2JqBAq7.js";
import { ScrollArea } from "./internal/components/ScrollArea.js";
import { jsx, jsxs } from "react/jsx-runtime";
import * as RadixTabs from "@radix-ui/react-tabs";
//#region src/components/Tabs/styles.ts
const tabsListWrapperClass = "tw:shrink-0 tw:border-t-0 tw:border-x-0 tw:border-b tw:border-solid tw:border-border";
const tabsListClass = "tw:flex tw:gap-8 tw:shrink-0 tw:w-max";
const tabsTriggerGroupClass = "tw:group/tab-trigger-group tw:flex tw:shrink-0 tw:items-center";
const tabsTriggerClass = "tw:focus-visible:outline-hidden tw:focus-visible:ring-2 tw:focus-visible:ring-inset tw:focus-visible:ring-ring tw:flex tw:justify-center tw:items-center tw:gap-1.5 tw:bg-transparent tw:shrink-0 tw:border-t-0 tw:border-x-0 tw:border-b-[3px] tw:border-solid tw:border-transparent tw:pt-2.5 tw:pb-5 tw:px-0 tw:m-0 tw:font-medium tw:leading-5 tw:text-muted-foreground tw:text-base tw:data-[state=active]:text-primary tw:data-[state=active]:border-primary tw:data-[disabled]:text-muted-foreground tw:data-[disabled]:opacity-disabled tw:data-[disabled]:cursor-not-allowed tw:group-hover/tab-trigger-group:enabled:text-primary tw:group-hover/tab-trigger-group:enabled:border-primary tw:group-hover/tab-trigger-group:enabled:cursor-pointer";
//#endregion
//#region src/components/Tabs/TabsList.tsx
const TabsList = ({ className, children, ...rest }) => /* @__PURE__ */ jsx(ScrollArea, {
	orientation: "horizontal",
	className: tabsListWrapperClass,
	children: /* @__PURE__ */ jsx(RadixTabs.List, {
		...rest,
		"data-slot": "tabs-list",
		className: cn(tabsListClass, className),
		children
	})
});
//#endregion
//#region src/components/Tabs/TabsTrigger.tsx
const TabsTrigger = ({ className, compact = false, ...rest }) => /* @__PURE__ */ jsx(RadixTabs.Trigger, {
	"data-slot": "tabs-trigger",
	...rest,
	className: cn(tabsTriggerClass, compact && "tw:text-sm tw:pb-4", className)
});
//#endregion
//#region src/components/Tabs/Tabs.tsx
const Tabs = ({ triggers, compact = false, children, defaultValue, onValueChange, rootClassName, listClassName, triggerClassName, triggerGroupClassName, ...rest }) => /* @__PURE__ */ jsxs(RadixTabs.Root, {
	...rest,
	"data-slot": "tabs-root",
	className: cn("tw:flex tw:flex-col tw:gap-6", rootClassName),
	defaultValue: defaultValue ?? triggers[0]?.value,
	onValueChange,
	children: [/* @__PURE__ */ jsx(TabsList, {
		className: listClassName,
		children: triggers.map(({ value, title, onClose, className: callerClassName, ...triggerRest }) => /* @__PURE__ */ jsxs("div", {
			className: cn(tabsTriggerGroupClass, triggerGroupClassName),
			"data-slot": "tabs-trigger-group",
			children: [/* @__PURE__ */ jsx(TabsTrigger, {
				value,
				compact,
				...triggerRest,
				className: cn(triggerClassName, callerClassName),
				children: title
			}), onClose && /* @__PURE__ */ jsx(Button, {
				type: "button",
				variant: "inline",
				size: "icon-3xs",
				disabled: triggerRest.disabled,
				onClick: () => onClose(value),
				onMouseDown: (e) => e.preventDefault(),
				className: "tw:!size-8 tw:opacity-0 tw:duration-200 tw:focus-visible:opacity-100 tw:group-focus-within/tab-trigger-group:opacity-100 tw:group-hover/tab-trigger-group:opacity-100",
				"aria-label": typeof title === "string" ? `Close ${title}` : "Close tab",
				children: /* @__PURE__ */ jsx(X, { className: "tw:size-4" })
			})]
		}, value))
	}), children]
});
//#endregion
//#region src/components/Tabs/TabsContent.tsx
const TabsContent = (props) => /* @__PURE__ */ jsx(RadixTabs.Content, {
	"data-slot": "tabs-content",
	tabIndex: -1,
	...props
});
//#endregion
export { Tabs, TabsContent };

//# sourceMappingURL=Tabs-C0uvkPHc.js.map